import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';
import Login from '../views/Login.vue';
import Pricing from '../views/Pricing.vue';
import Features from '../views/Features.vue';
import Privacy from '../views/Privacy.vue';
import Terms from '../views/Terms.vue';
import Contact from '../views/Contact.vue';
import '../style.css';

const routes = [
  { 
    path: '/', name: 'Home', component: Home,
  },
  {
    path: '/login', name: 'Login', component: Login
  },
  {
    path: '/pricing', name: 'Pricing', component: Pricing
  },
  {
    path: '/features', name: 'Features', component: Features
  },
  {
    path: '/privacy', name: 'Privacy', component: Privacy
  },
  {
    path: '/terms', name: 'Terms', component: Terms
  },
  {
    path: '/contact', name: 'Contact', component: Contact
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to) {
    if(to.hash) {
        return {
            el: to.hash,
            behavior: 'smooth'
        };
    }
  }
});

export default router;
